/** Default policy pages (seed for DB and client fallback). */
export const POLICY_PAGES_DEFAULTS = {
  shipping: {
    slug: 'shipping',
    title: 'Shipping & delivery',
    seoDescription: 'Shipping and delivery information for Saloni Designs orders across India.',
    lastUpdated: '2026-07-07',
    sections: [
      {
        heading: 'Delivery across India',
        body: 'We ship handcrafted Rakhi and Lumba orders to addresses throughout India. Delivery details are confirmed when you place your order.',
      },
      {
        heading: 'Processing time',
        body: 'Orders are prepared after payment confirmation (or after we confirm offline payment, when online payment is not enabled). During festival seasons, allow a few extra days — we will contact you if timing changes.',
      },
      {
        heading: 'Shipping charges',
        body: 'A flat delivery fee may apply at checkout (shown before you place your order). Complimentary delivery may be offered on selected promotions — the checkout page will show the exact amount.',
      },
      {
        heading: 'Tracking',
        body: 'When your order ships, we will share tracking or courier details by phone or WhatsApp when available.',
      },
    ],
  },
  returns: {
    slug: 'returns',
    title: 'Returns & exchanges',
    seoDescription: 'Returns and exchange policy for Saloni Designs handcrafted jewelry.',
    lastUpdated: '2026-07-07',
    sections: [
      {
        heading: 'Handcrafted pieces',
        body: 'Each Saloni Designs piece is made by hand. Minor variations in colour, size, or finish are part of the craft and are not considered defects.',
      },
      {
        heading: 'Damaged or incorrect items',
        body: 'If your order arrives damaged or is not what you ordered, contact us within 48 hours of delivery with photos. We will work with you on a replacement or refund where appropriate.',
      },
      {
        heading: 'Custom & personalized orders',
        body: 'Personalized or custom-made items cannot be returned unless they arrive damaged or incorrect.',
      },
      {
        heading: 'How to reach us',
        body: 'Message us on WhatsApp or email with your order number. We aim to respond within one business day.',
      },
    ],
  },
  privacy: {
    slug: 'privacy',
    title: 'Privacy policy',
    seoDescription: 'How Saloni Designs collects and uses your personal information.',
    lastUpdated: '2026-07-07',
    sections: [
      {
        heading: 'Information we collect',
        body: 'When you create an account or place an order, we collect your name, contact details, and delivery address. Payment processing is handled by Razorpay when online payment is enabled — we do not store card numbers on our servers.',
      },
      {
        heading: 'How we use it',
        body: 'We use your information to fulfil orders, contact you about delivery or payment, and improve our service. We do not sell your personal data to third parties.',
      },
      {
        heading: 'Cookies & local storage',
        body: 'The website may store your shopping bag and sign-in session in your browser so the shop works smoothly.',
      },
      {
        heading: 'Your choices',
        body: 'You may update your profile in My account or contact us to ask about your data. You can sign out at any time from the header menu.',
      },
    ],
  },
};
